import React, { useState } from 'react';
import { Layout } from '../components/layout/Layout';
import { Calendar, User, ArrowRight, Clock } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blogData';
const categories = ['All', 'Faith', 'Community', 'Devotional', 'Family', 'Scripture', 'Worship'];
export function BlogPage() {
  const [activeCategory, setActiveCategory] = useState('All');
  const filteredPosts = activeCategory === 'All' ? blogPosts : blogPosts.filter(post => post.category === activeCategory);
  const featuredPost = blogPosts.find(post => post.featured);
  const regularPosts = filteredPosts.filter(post => !post.featured || activeCategory !== 'All');
  return <Layout data-id="element-376">
      {/* Header */}
      <div className="bg-[#0A1F44] pt-44 md:pt-48 pb-20 text-center text-white relative overflow-hidden" data-id="element-377">
        <div className="absolute inset-0 opacity-20" data-id="element-378">
          <img src="https://images.unsplash.com/photo-1457369804613-52c61a468e7d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Background" className="w-full h-full object-cover" data-id="element-379" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1F44] via-[#0A1F44]/70 to-[#0A1F44]" data-id="element-380" />
        <div className="container-custom relative z-10" data-id="element-381">
          <h1 className="text-4xl md:text-6xl font-serif font-bold mb-4" data-id="element-382">
            Blog
          </h1>
          <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-383">
            Insights, devotionals, and encouragement for your faith journey.
          </p>
        </div>
      </div>

      {/* Category Filter */}
      <div className="bg-white border-b sticky top-16 z-30" data-id="element-384">
        <div className="container-custom py-4" data-id="element-385">
          <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide" data-id="element-386">
            {categories.map(category => <button key={category} onClick={() => setActiveCategory(category)} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${activeCategory === category ? 'bg-[#0A1F44] text-white' : 'bg-[#F5F7FA] text-[#0A1F44] hover:bg-[#e2e8f0]'}`} data-id="element-387">
                {category}
              </button>)}
          </div>
        </div>
      </div>

      {/* Featured Post */}
      {activeCategory === 'All' && featuredPost && <section className="py-12 bg-[#F5F7FA]" data-id="element-388">
          <div className="container-custom" data-id="element-389">
            <motion.article initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="grid grid-cols-1 lg:grid-cols-2 gap-8 bg-white rounded-2xl overflow-hidden shadow-lg" data-id="element-390">
              <div className="relative h-64 lg:h-auto" data-id="element-391">
                <img src={featuredPost.image} alt={featuredPost.title} className="w-full h-full object-cover" data-id="element-392" />
                <div className="absolute top-4 left-4" data-id="element-393">
                  <span className="bg-[#C8102E] text-white px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider" data-id="element-394">
                    Featured
                  </span>
                </div>
              </div>
              <div className="p-8 lg:p-12 flex flex-col justify-center" data-id="element-395">
                <span className="text-[#0A1F44] text-sm font-semibold uppercase tracking-wider mb-3" data-id="element-396">
                  {featuredPost.category}
                </span>
                <Link to={`/blog/${featuredPost.id}`} data-id="element-397">
                  <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#0A1F44] mb-4 hover:text-[#C8102E] transition-colors cursor-pointer" data-id="element-398">
                    {featuredPost.title}
                  </h2>
                </Link>
                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-399">
                  {featuredPost.excerpt}
                </p>
                <div className="flex items-center gap-4 text-sm text-gray-500 mb-6" data-id="element-400">
                  <span className="flex items-center gap-1" data-id="element-401">
                    <User className="w-4 h-4" data-id="element-402" />
                    {featuredPost.author}
                  </span>
                  <span className="flex items-center gap-1" data-id="element-403">
                    <Calendar className="w-4 h-4" data-id="element-404" />
                    {featuredPost.date}
                  </span>
                  <span className="flex items-center gap-1" data-id="element-405">
                    <Clock className="w-4 h-4" data-id="element-406" />
                    {featuredPost.readTime}
                  </span>
                </div>
                <Link to={`/blog/${featuredPost.id}`} className="inline-flex items-center text-[#0A1F44] font-semibold hover:text-[#C8102E] transition-colors group" data-id="element-407">
                  Read Full Article{' '}
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-408" />
                </Link>
              </div>
            </motion.article>
          </div>
        </section>}

      {/* Regular Posts Grid */}
      <section className="py-16 bg-white" data-id="element-409">
        <div className="container-custom" data-id="element-410">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-411">
            {regularPosts.map((post, index) => <motion.article key={post.id} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow border border-gray-100 flex flex-col" data-id="element-412">
                <Link to={`/blog/${post.id}`} className="block relative h-48" data-id="element-413">
                  <img src={post.image} alt={post.title} className="w-full h-full object-cover" data-id="element-414" />
                  <div className="absolute top-4 left-4" data-id="element-415">
                    <span className="bg-white/90 backdrop-blur-sm text-[#0A1F44] px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider" data-id="element-416">
                      {post.category}
                    </span>
                  </div>
                </Link>
                <Link to={`/blog/${post.id}`} className="p-6 flex-1 flex flex-col block group" data-id="element-417">
                  <div className="flex-1" data-id="element-418">
                    <h3 className="text-xl font-serif font-bold text-[#0A1F44] mb-3 group-hover:text-[#C8102E] transition-colors line-clamp-2" data-id="element-419">
                      {post.title}
                    </h3>
                    <p className="text-gray-600 mb-4 line-clamp-3 text-sm leading-relaxed" data-id="element-420">
                      {post.excerpt}
                    </p>
                    <div className="flex items-center justify-between text-xs text-gray-500" data-id="element-421">
                      <span className="flex items-center gap-1" data-id="element-422">
                        <User className="w-3 h-3" data-id="element-423" />
                        {post.author}
                      </span>
                      <span className="flex items-center gap-1" data-id="element-424">
                        <Calendar className="w-3 h-3" data-id="element-425" />
                        {post.date}
                      </span>
                    </div>
                  </div>
                </Link>
              </motion.article>)}
          </div>

          {/* Load More */}
          <div className="text-center mt-12" data-id="element-426">
            <button className="px-8 py-3 border-2 border-[#0A1F44] text-[#0A1F44] rounded-md font-medium hover:bg-[#0A1F44] hover:text-white transition-colors" data-id="element-427">
              Load More Articles
            </button>
          </div>
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className="py-16 bg-[#0A1F44]" data-id="element-428">
        <div className="container-custom text-center" data-id="element-429">
          <h2 className="text-3xl font-serif font-bold text-white mb-4" data-id="element-430">
            Stay Connected
          </h2>
          <p className="text-white/80 mb-8 max-w-xl mx-auto" data-id="element-431">
            Subscribe to our newsletter for weekly devotionals, church updates,
            and encouragement delivered straight to your inbox.
          </p>
          <form className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto" data-id="element-432">
            <input type="email" placeholder="Enter your email" className="flex-1 px-4 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#C8102E]" data-id="element-433" />
            <button type="submit" className="px-6 py-3 bg-[#C8102E] text-white rounded-md font-medium hover:bg-[#A00D24] transition-colors" data-id="element-434">
              Subscribe
            </button>
          </form>
        </div>
      </section>
    </Layout>;
}